<script setup lang="ts">
import MtLoadingAnimationLinear from "@/components/UI/mtLoadingAnimationLinear/mtLoadingAnimationLinear.vue";

interface Props {
  loading: boolean;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="loader-wrapper">
    <mt-loading-animation-linear v-if="loading"/>

    <slot v-else/>
  </div>
</template>